<script lang="ts" setup>
type Page = {
  __typename?: 'Page';
  Components?: Maybe<Array<Maybe<PageComponentsDynamicZone>>>;
  Name: Scalars['String'];
  Order?: Maybe<Scalars['Int']>;
  Slug: Scalars['String'];
  Titel: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  footer?: Maybe<ComponentBlockFooter>;
  header: Array<Maybe<PageHeaderDynamicZone>>;
  locale?: Maybe<Scalars['String']>;
  localizations?: Maybe<PageRelationResponseCollection>;
  page_categories?: Maybe<PageCategoryRelationResponseCollection>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  seo?: Maybe<ComponentSharedSeo>;
  short_title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
}
const props = defineProps<Page>();
setSeo(props.seo, props.localizations, "website");
</script>
<template>
  <div>
    <BlockHeaderRenderer
      v-for="(header, index) in props.header"
      v-bind="header"
      :key="`${header?.__typename}-${index}`"
    />
    <BlockRenderer
      v-for="(block, index) in props.Components"
      v-bind="block"
      :key="`${block?.__typename}-${index}`"
    />
  </div>
</template>
